<template lang="">
  <v-dialog v-model="dialog" width="620px">
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <v-btn
          class="v-btn--outlined theme--white v-size--small primary--text pa-4 font-weight-bold btn-color"
          depressed
        >
          Hồ sơ chi tiết
        </v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>CHI TIẾT {{ titleType.toUpperCase() }}</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text class="detail py-3">
        <h3>1. Thông tin cơ bản</h3>
        <div class="py-3">
          <v-row>
            <v-col :cols="5">
              <span>Nhóm</span>
            </v-col>
            <v-col :cols="4">
              <h4>{{ headFee.salary_collection && headFee.salary_collection.title }}</h4>
            </v-col>
          </v-row>
        </div>
        <div class="py-3">
          <v-row>
            <v-col :cols="5">
              <span> Khoản {{ titleType }} </span>
            </v-col>
            <v-col :cols="5">
              <h4>
                {{ headFee.title }}
              </h4>
            </v-col>
          </v-row>
        </div>
        <div class="py-3" v-if="router !== 'main'">
          <v-row>
            <v-col cols="5">
              <span>Áp dụng với khoản phí thu đóng</span>
            </v-col>
            <v-col cols="7">
              <h4>{{ headFee.salary_head_apply && headFee.salary_head_apply.title }}</h4>
            </v-col>
          </v-row>
        </div>
        <div class="py-3" v-if="isSubFee === false">
          <v-row>
            <v-col :cols="5">
              <span>Phân loại</span>
            </v-col>
            <v-col :cols="4">
              <h4>{{ headFee.type === 'sum' ? 'Thưởng' : 'Phạt' }}</h4>
            </v-col>
          </v-row>
        </div>
        <div class="py-3">
          <v-row>
            <v-col :cols="5">
              <span>Ghi chú</span>
            </v-col>
            <v-col :cols="5">
              <h4>{{ headFee.note }}</h4>
            </v-col>
          </v-row>
        </div>
        <h3>2. Thông tin hiển thị</h3>
        <div class="py-3">
          <v-row>
            <v-col :cols="5">
              <span>Tên hiển thị ngắn</span>
            </v-col>
            <v-col :cols="5">
              <h4>{{ headFee.metadata && headFee.metadata.shortName }}</h4>
            </v-col>
          </v-row>
        </div>
        <div class="py-3">
          <v-row>
            <v-col :cols="5">
              <span>Ưu tiên hiển thị</span>
            </v-col>
            <v-col :cols="5">
              <h4>{{ headFee.rank && headFee.rank }}</h4>
            </v-col>
          </v-row>
        </div>
        <div class="py-3">
          <v-row>
            <v-col :cols="5">
              <span>Ghi chú hiển thị</span>
            </v-col>
            <v-col :cols="5">
              <h4>{{ headFee.metadata && headFee.metadata.subNote }}</h4>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card outlined color="transparent">
        <v-divider></v-divider>
        <v-card-actions class="mt-5">
          <v-spacer />
          <UpdateDialog v-if="canUpdate" />
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import UpdateDialog from '../info-dialog/UpdateDialog.vue'
export default {
  components: {
    UpdateDialog
  },
  props: {
    headFee: Object
  },
  data() {
    return {
      dialog: false,
      loading: false,
      updateDialog: false
    }
  },
  computed: {
    ...mapState('salaryHead', ['router', 'isSubFee']),
    titleType() {
      return this.$route.meta.title.replace('Chi tiết', '')
    },
    canUpdate() {
      return true
    }
  },
  methods: {
    openDialog() {
      this.dialog = true
    },
    cancel() {
      this.dialog = false
    }
  }
}
</script>
<style lang="scss" scoped>
h3 {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #212121;
}
.detail h4 {
  color: black;
  font-weight: 400;
  font-size: 14px;
}
</style>
